import { defineMessages, IntlShape } from "react-intl";

import SandboxStatus from "@mapmycustomers/shared/enum/SandboxStatus";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<SandboxStatus>({
  [SandboxStatus.ACTIVE]: {
    id: "sandboxStatus.active",
    defaultMessage: "Active",
    description: "SandboxStatus - Active",
  },
  [SandboxStatus.CLONING]: {
    id: "sandboxStatus.Cloning",
    defaultMessage: "Cloning",
    description: "SandboxStatus - Cloning",
  },
  [SandboxStatus.COMPLETED]: {
    id: "sandboxStatus.completed",
    defaultMessage: "Completed",
    description: "SandboxStatus - Completed",
  },
  [SandboxStatus.DELETING]: {
    id: "sandboxStatus.deleting",
    defaultMessage: "Deleting",
    description: "SandboxStatus - Deleting",
  },
  [SandboxStatus.ERRORED]: {
    id: "sandboxStatus.errored",
    defaultMessage: "Error",
    description: "SandboxStatus - Error",
  },
});

const getSandboxStatusDisplayName = (intl: IntlShape, status: SandboxStatus): string =>
  getDisplayName(intl, messages, status, "SandboxStatus");

export default getSandboxStatusDisplayName;
